import * as React from "react";
import { cn } from "../../lib/utils";

const badgeVariants = {
    default: "bg-[#082359] text-white",
    secondary: "bg-gray-500 text-white",
    success: "bg-green-600 text-white",
    danger: "bg-red-600 text-white",
    warning: "bg-yellow-500 text-white",
    info: "bg-cyan-500 text-white",
    outline: "border border-current text-current bg-transparent",
};

function Badge({ className, variant = "default", children, style, ...props }) {
    return (
        <span
            className={cn(
                "inline-flex items-center rounded px-2 py-0.5 text-xs font-semibold",
                badgeVariants[variant] || badgeVariants.default,
                className
            )}
            style={style}
            {...props}
        >
            {children}
        </span>
    );
}

export { Badge };
